import type { PreparedStarterInfo } from '@racemap/utilities/functions/timing';
import type { Immutable } from 'immer';
import type { FC, ReactNode } from 'react';
import { TextCell } from './BasicCell';

interface Props {
  starterInfo: Immutable<PreparedStarterInfo>;
}

const StartNumberColComponent: FC<Props> = ({ starterInfo }) => {
  return <TextCell title={starterInfo?.startNumber}>{starterInfo?.startNumber}</TextCell>;
};

export const starterNumberCol = {
  key: 'start_number',
  title: 'Race №',
  width: 80,
  className: 'starter-number-value-cell',
  render: function renderer(row: Immutable<PreparedStarterInfo>): ReactNode {
    return <StartNumberColComponent starterInfo={row} />;
  },
  sorter: (a: Immutable<PreparedStarterInfo>, b: Immutable<PreparedStarterInfo>): number => {
    if (a?.startNumber == null || a?.startNumber === '') return 1;
    if (b?.startNumber == null || a?.startNumber === '') return -1;
    return a?.startNumber.localeCompare(b?.startNumber, 'en', {
      numeric: true,
    });
  },
};
